export default "__VITE_ASSET__wTOGvgyb__"